
// 本地开发请求代理前缀
export const PROXY_PREFIX = '/prod-api'

let temp01 = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqN9+zh3k1WO8B9DZQq+'
let temp021 = 'YDjHm3Tvskt'
let temp022 = 'PKpYY65JM0qJACf'
let temp023 = 'OrS7nU7BQAAH5U6A9YK0TFJ5myJq3H3cEN4iv'
let temp03 = 'TIxAAJ0pIXnIQzrg+NCx97FTYEnQlM/gMJKtTFq7NJVgcgRnWlMefS4t6+a2mtl'
let temp04 = 'R6Jf3/dddvOUUvSZe8iRPRcrVgsZUwVIUGbtRbMhr1uI5CYvMZL1BIp4P/LHyEO7o1'
let temp05 = 'd5PG2h05QcoAZsIwSlV1gyFLPvcizTjcoipkqRXkmfUAoboxlLmzKLPaH2N63uwcXvBmpWEb'
let temp06 = '/sBuGLVqJZabkCr89RqDfFRgvdg1fnu900TqDxIvehGYc3CWtGWgwFbktKQIDAQAB'

export const PUBLIC_KEY = temp01 + temp021 + temp022 + temp023 + temp03 + temp04 + temp05 + temp06
